module.exports = __webpack_public_path__ + "static/img/4.10146a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/4.png
// module id = tcRz
// module chunks = 0